// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__gC9ba","spinner":"LoadingSpinner_spinner__SxuR1"};